import { FC } from 'react';
import { Field, FieldProps } from 'react-final-form';

import CaptchaField from '../../form/CaptchaField';

export const ReCaptchaField: FC<Partial<FieldProps<string, HTMLInputElement>>> = props => (
  <Field name="captcha" component={CaptchaField} {...props} />
);
